import { motion } from "framer-motion";
import { styled } from "styled-components";
import { theme as styleTheme } from "../styles";
import Container from "./Container";
import { CloseCircleIcon } from "../assets/svg";

const Modal = ({
  open = false,
  cancel,
  accept,
  children,
  theme = "brand",
  handleCancel,
  handleAccept,
}) => {
  return (
    <>
      {open && (
        <Backdrop
          initial={styleTheme.fadeIn.initial}
          animate={styleTheme.fadeIn.animate}
          exit={styleTheme.fadeIn.initial}
          transition={styleTheme.fadeIn.transition(0)}
        >
          <Container>
            <CloseButton onClick={() => handleCancel()}>
              <CloseCircleIcon />
            </CloseButton>
            <ModalWrapper>
              {children}
              {cancel && accept && (
                <ButtonGroup>
                  <Cancel onClick={() => handleCancel()}>{cancel}</Cancel>
                  <Accept $theme={theme} onClick={() => handleAccept()}>
                    {accept}
                  </Accept>
                </ButtonGroup>
              )}
              {cancel && !accept && (

<CancelAlone onClick={() => handleCancel()}>{cancel}</CancelAlone>
              )}
            </ModalWrapper>
          </Container>
        </Backdrop>
      )}
    </>
  );
};

export const Backdrop = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${(props) =>
    props.theme.backgroundColor + props.theme.clear75};
  backdrop-filter: blur(8px);

  z-index: 10;
`;

const ModalWrapper = styled.div`
  padding: ${(props) => props.theme.spaceXl};
  margin: ${(props) => props.theme.spaceLg};

  text-align: center;

  background-color: ${(props) => props.theme.foregroundColor};
  border-radius: ${(props) => props.theme.borderRadiusMd};

  @media only screen and (min-width: ${(props) =>
      props.theme.breakpoints.width.sm}) {
    min-width: ${(props) => props.theme.breakpoints.width.sm};
  }
`;

const ButtonGroup = styled.div`
  margin-top: ${(props) => props.theme.spaceXl};
  display: flex;
  justify-content: center;
  gap: ${(props) => props.theme.spaceXl};
`;

const Cancel = styled.button`
  padding: ${(props) => `${props.theme.spaceMd} ${props.theme.spaceLg}`};
  color: ${(props) => props.theme.mutedColor};
  background-color: transparent;
  border: 2px solid ${(props) => props.theme.mutedColor};

  &:hover {
    color: ${(props) => props.theme.textColor};
    border: 2px solid ${(props) => props.theme.textColor};
  }
`;

const CancelAlone = styled(Cancel)`
margin-left: auto;
margin-right: auto;
margin-top: ${props => props.theme.spaceLg}
`;

const Accept = styled(Cancel)`
  color: ${(props) => props.theme[props.$theme]};
  border-color: ${(props) => props.theme[props.$theme]};

  &:hover {
    color: ${(props) => props.theme.foregroundColor};
    background-color: ${(props) => props.theme[props.$theme]};
    border-color: ${(props) => props.theme[props.$theme]};
  }
`;
const CloseButton = styled.button`
  width: fit-content;
  padding: 0;
  margin: 0;

  display: block;
  align-self: end;

  color: ${(props) => props.theme.mutedColor};
  background: none;
  border: none;

  &:hover {
    color: ${(props) => props.theme.textColor};
  }
`;

export default Modal;
